import { createContext } from 'react';
const UserInfoContext = /*#__PURE__*/createContext(null);
export default UserInfoContext;